var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomTicTacToe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8875 16.9C27.5 15.7125 26.2062 15.0813 25.0125 15.4688L22.175 16.4125L20.2812 10.7875L23.1187 9.84377C24.3125 9.45627 24.9375 8.16877 24.5562 6.97502C24.1687 5.78752 22.875 5.15627 21.6812 5.54377L18.8437 6.48752L17.8625 3.55002C17.475 2.36252 16.1812 1.73127 14.9875 2.11877C13.7937 2.50627 13.1687 3.79377 13.55 4.98752L14.5312 7.92502L8.69374 9.87502L7.71249 6.93752C7.32499 5.75002 6.03124 5.11877 4.83749 5.50627C3.64374 5.89377 3.01874 7.18127 3.39999 8.37502L4.38124 11.3125L1.54999 12.25C0.356238 12.6375 -0.268762 13.925 0.112488 15.1188C0.424988 16.025 1.30624 16.6188 2.21249 16.6563C2.63749 16.7188 2.96249 16.5563 5.81874 15.6063L7.71249 21.2313L4.87499 22.175C3.68749 22.5625 3.05624 23.8563 3.43749 25.0438C3.74999 25.95 4.63124 26.5438 5.53749 26.5813C5.96249 26.6438 6.28749 26.4813 9.14374 25.5313L10.125 28.4688C10.4937 29.525 11.6687 30.2813 13 29.9C14.1937 29.5125 14.8187 28.225 14.4375 27.0313L13.4562 24.0938L19.3062 22.1375L20.2875 25.075C20.6562 26.1313 21.8312 26.8875 23.1625 26.5063C24.3562 26.1188 24.9812 24.8313 24.6 23.6375L23.6187 20.7L26.4562 19.7563C27.6437 19.3813 28.275 18.0875 27.8875 16.9V16.9ZM12.0062 19.85L10.1125 14.2125L15.9562 12.2563L17.85 17.8938L12.0062 19.85V19.85Z",
    fill: "url(#paint0_radial_11_2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_11_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.0012 16.0025) rotate(90) scale(13.9977 14.0002)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007862"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EEC3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomTicTacToe);
export default __webpack_public_path__ + "static/media/custom_ticTacToe.f985f88792e07d646364d96242ae4efc.svg";
export { ForwardRef as ReactComponent };